import { BaseResource } from "./base.resource";

export const ProcessCategoryAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class ProcessCategory extends BaseResource {
  active: boolean;
  name: string;
  disposalMethod: string;
  costFactor: string;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & ProcessCategoryAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & ProcessCategoryAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & ProcessCategoryAccessLevel.Delete) > 0;
  }
}
